import React from 'react';
import PropTypes from 'prop-types';
import keygen from '~helpers/keygen';

export default function CopyIcon({ width = 23, height = 22, color = '#262629' }) {
  const key = keygen();

  return (
    <svg
      role="img"
      aria-labelledby={`copyIcon_${key}`}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id={`copyIcon_${key}`}>Copy Icon</title>
      <g id={`Icon_${key}`}>
        <path
          id={`Vector_${key}`}
          d="M17.9165 8.15742C17.9085 8.08584 17.8932 8.01532 17.8707 7.94704V7.87692C17.8339 7.7968 17.7849 7.72316 17.7255 7.65875L13.1422 2.98375C13.0791 2.92314 13.0069 2.87317 12.9283 2.83571C12.9055 2.8324 12.8824 2.8324 12.8596 2.83571C12.782 2.79032 12.6963 2.76118 12.6075 2.75H9.51373C8.90594 2.75 8.32304 2.99627 7.89327 3.43464C7.4635 3.873 7.22206 4.46756 7.22206 5.0875V5.86667H6.45817C5.85038 5.86667 5.26749 6.11294 4.83772 6.5513C4.40795 6.98967 4.1665 7.58422 4.1665 8.20417V15.9958C4.1665 16.6158 4.40795 17.2103 4.83772 17.6487C5.26749 18.0871 5.85038 18.3333 6.45817 18.3333H12.5693C13.1771 18.3333 13.76 18.0871 14.1897 17.6487C14.6195 17.2103 14.8609 16.6158 14.8609 15.9958V15.2167H15.6248C16.2326 15.2167 16.8155 14.9704 17.2453 14.532C17.6751 14.0937 17.9165 13.4991 17.9165 12.8792V8.20417C17.9165 8.20417 17.9165 8.20417 17.9165 8.15742ZM13.3332 5.40696L15.3116 7.425H14.0971C13.8945 7.425 13.7002 7.34291 13.5569 7.19679C13.4137 7.05067 13.3332 6.85248 13.3332 6.64583V5.40696ZM13.3332 15.9958C13.3332 16.2025 13.2527 16.4007 13.1094 16.5468C12.9662 16.6929 12.7719 16.775 12.5693 16.775H6.45817C6.25557 16.775 6.06128 16.6929 5.91802 16.5468C5.77476 16.4007 5.69428 16.2025 5.69428 15.9958V8.20417C5.69428 7.99752 5.77476 7.79934 5.91802 7.65321C6.06128 7.50709 6.25557 7.425 6.45817 7.425H7.22206V12.8792C7.22206 13.4991 7.4635 14.0937 7.89327 14.532C8.32304 14.9704 8.90594 15.2167 9.51373 15.2167H13.3332V15.9958ZM16.3887 12.8792C16.3887 13.0858 16.3082 13.284 16.165 13.4301C16.0217 13.5762 15.8274 13.6583 15.6248 13.6583H9.51373C9.31113 13.6583 9.11683 13.5762 8.97358 13.4301C8.83032 13.284 8.74984 13.0858 8.74984 12.8792V5.0875C8.74984 4.88085 8.83032 4.68267 8.97358 4.53655C9.11683 4.39042 9.31113 4.30833 9.51373 4.30833H11.8054V6.64583C11.8054 7.26578 12.0468 7.86033 12.4766 8.2987C12.9064 8.73706 13.4893 8.98333 14.0971 8.98333H16.3887V12.8792Z"
          fill={color}
        />
      </g>
    </svg>
  );
}

CopyIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};
